<template>
  <v-container style="max-width: 1280px">
    <v-row justify="center">
    <v-col cols="12" md="12">
      <v-card outlined>
        <v-card-subtitle>
          Step 3 / 5
        </v-card-subtitle>
        <v-progress-linear height="10" :value="progress" striped></v-progress-linear>
      </v-card>
    </v-col>
  </v-row>
    <!-- Quiz View -->
    <v-row justify="center" v-if="state == 0">
      <v-col cols="12" md="12">
        <v-card outlined>
          <v-card-title class="justify-center">
            General Needs
          </v-card-title>
          <v-card-subtitle class="text-center">
            Please answer each question as they apply to you.<br>
            You may skip any questions that you do not wish to answer.
          </v-card-subtitle>
          <v-divider></v-divider>
          <question-list 
            :questions="questions"
            :responses="responses"
            @responses-updated="on_update_responses"
            :page_length="16"
          />
        </v-card>
      </v-col>
    </v-row>

    <!-- Pie Chart View-->
    <v-row justify="center" v-if="responses_valid">
      <v-col cols="12" md="12">
        <pie-chart
          :title="title"
          :data="chart_data"
        />
      </v-col>
    </v-row>

    <v-row justify="center" v-if="responses_valid">
      <v-col cols="12">
        <v-card outlined>
          <v-card-title class="justify-center">
            Your Results
          </v-card-title>
          <v-card-subtitle class="text-center">
            Does this represent the way you feel about your general needs?<br>
            If not, you can update your answers.
          </v-card-subtitle>
          <v-divider></v-divider>
          <v-card-text>
            <v-alert class="mb-0" color="deep-orange" type="info">
            {{ major_issue.issue.message_general }}
            </v-alert>
            <v-alert class="mb-0 mt-4" type="success" color="deep-purple lighten-1" v-if="major_issue.christian">
            {{ major_issue.issue.christian_general }}
            </v-alert>
            <christian-alert
              v-if="major_issue.christian"
              :message="major_issue.issue.christian_general"
              :major_issue="major_issue.issue.major_issue"
            />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row justify="center" v-if="responses_valid">
      <v-col cols="12">
        <v-card outlined>
          <v-card-actions class="justify-center pa-3">
            <v-btn color="primary" :disabled="response_count == 0" @click="finish">
              Continue
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// List of questions.
import Questions from '../include/questions-general.json';

// Components.
import PieChart from '../components/PieChart.vue';
import QuestionList from '../components/QuestionList.vue';
import ChristianAlert from '../components/ChristianAlert.vue';

export default {
  name: "GeneralQuiz",
  components: {
    PieChart,
    QuestionList,
    ChristianAlert
  },
  data: () => ({
    // State
    state: 0,
    major_issue: {},

    // Pie chart.
    title: 'My General Needs Pie',
    headers: ['Answer', 'Value'],
    data: [
        ['Bad',     0],
        ['Ok',      0],
        ['Good',    0],
        ['Unused',  100]
    ],

    questions: [],
    responses: [],

    total_points: {
      bad: 0,
      ok: 0,
      good: 0,
      sum: 0
    },

    points_frac: {

    }
  }),
  computed: {
    progress: function() {
      return this.responses_valid ? 75 : 50;
    },

    // Chart data accessor.
    chart_data: function() {
      return [this.headers, ...this.data]
    },

    response_count: function() {
      return this.responses.filter(r => r.response != 'Skip').length > 0;
    },

    responses_valid: function() {
      return this.responses.filter(r => r.response == null).length == 0;
    }
  },
  methods: {
    on_update_responses: function(data) {
      this.responses = data.responses;
      this.total_points = data.points
      this.points_frac = data.points_frac;
      this.update_chart();
    },

    update_chart: function() {
      if (!this.responses_valid) {
        this.data = [
          ['Bad',     0],
          ['Ok',      0],
          ['Good',    0],
          ['Unused',  100]
        ];
        return;
      }
      
      var points = this.total_points;
      this.data = [
        ['Bad',     points.bad],
        ['Ok',      points.ok],
        ['Good',    points.good],
        ['Unused',  points.sum == 0 ? 1 : 0]
      ]
    },

    finish: function() {
      var query = this.$route.query;

      var values = JSON.stringify({
        responses: this.responses.filter(r => r.response != 'Skip'),
        points: this.total_points
      });
      
      this.$router.push({
        path: '/refined',
        query: {
          major_issue: query.major_issue,
          initial: query.initial,
          general: values
        }
      });
    }
  },
  mounted() {
    this.major_issue = JSON.parse(this.$route.query.major_issue);
    this.questions = Questions;
    this.questions.forEach(q => {
      this.responses.push({
        question: q.question,
        category: q.category,
        response: null
      });
    });
  }
}
</script>